import React, { useEffect } from "react";
import { useTable, usePagination } from "react-table";
import createPagination from "../Hooks/usePagination";
import { MdCompareArrows } from "react-icons/md";

const SalesRankingTable = ({
    columns,
    data,
    updatePagination,
    paginationState,
    pageCount: controlledPageCount,
    hideHeader,
    sortable,
    hidePagination,
    alignLeft,
    hiddenFields,
}) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        gotoPage,
        previousPage,
        nextPage,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            manualPagination: true,
            pageCount: controlledPageCount,
            initialState: {
                pageIndex: 0,
                hiddenColumns: hiddenFields ? hiddenFields : [],
            },
        },
        usePagination
    );

    useEffect(() => {
        if (updatePagination) {
            updatePagination((prev) => ({
                ...prev,
                limit: pageSize,
                page: pageIndex + 1,
            }));
        }
    }, [updatePagination, pageIndex, pageSize]);

    const { pagination } = createPagination({
        numberOfButtons: 2,
        currentPage: paginationState ? paginationState.page : pageIndex + 1,
        totalPages: paginationState
            ? paginationState.totalPages
            : controlledPageCount,
    });

    return (
        <div className="m-auto table-wrapper block max-w-mobileFit lg:max-w-full overflow-y-hidden salesRankingTableWidth">
            <table className="greyOpaqueBackground w-full" {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => {
                                return hideHeader === true ? null : (
                                    <th
                                        className={`p-4 bg-cool-gray border-t font-semibold text-lynch text-xs w-24`}
                                        {...column.getHeaderProps()}
                                    >
                                        <div
                                            className={`flex items-center ${
                                                alignLeft
                                                    ? "justify-start"
                                                    : "justify-center"
                                            }`}
                                        >
                                            <div className="whitespace-no-wrap">
                                                {column.render("Header")}
                                            </div>
                                            {sortable && (
                                                <div className="cursor-pointer ml-2">
                                                    {sortable.includes(
                                                        column.id
                                                    ) && (
                                                        <MdCompareArrows
                                                            onClick={() => {
                                                                updatePagination(
                                                                    (prev) => ({
                                                                        ...prev,
                                                                        by: column.id,
                                                                        dir:
                                                                            prev.dir ===
                                                                            "asc"
                                                                                ? "desc"
                                                                                : "asc",
                                                                    })
                                                                );
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </th>
                                );
                            })}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <tr
                                className={
                                    row.original.status === "suspended"
                                        ? "bg-red-700 text-white"
                                        : row.original.status === "risksuspended"
                                        ? "bg-pink-600 text-white"
                                        : row.original.status === "cancel"
                                        ? "bg-red-700 text-white"
                                        : row.original.status === "converted"
                                        ? "bg-yellow-300 text-black"
                                        : row.original.status === "halfconverted"
                                        ? "bg-orange-300 text-black"
                                        : ""
                                }
                                {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => {
                                    return (
                                        <td
                                            className={`lg:p-4 p-2 py-4 text-sm border-t ${
                                                alignLeft
                                                    ? "text-left"
                                                    : "text-center"
                                            }`}
                                            {...cell.getCellProps()}
                                        >
                                            {cell.render("Cell")}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {!hidePagination && (
                <div className="p-4 bg-cool-gray border-t font-semibold text-lynch text-xs">
                    <ul className="flex justify-center pr-5 lg:justify-end">
                        <li
                            className="p-2 cursor-pointer"
                            onClick={() => previousPage()}
                        >
                            Previous
                        </li>
                        {pagination.map((page) => (
                            <li
                                className={`p-2 px-4 cursor-pointer ${
                                    page === pageIndex + 1
                                        ? "bg-darkblue text-white"
                                        : "text-xs"
                                }`}
                                key={page}
                                onClick={() => gotoPage(page - 1)}
                            >
                                {page}
                            </li>
                        ))}
                        <li
                            className="p-2 cursor-pointer"
                            onClick={() => nextPage()}
                        >
                            Next
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};


export default SalesRankingTable